<!-- Stepper container -->
<div class="main-container background">

  <!--Title of Compoients that will be in view   -->
  <p class="line-height-15 font-16 text-heading-color font-weight-500 title-container">
    {{ title }}
  </p>
  <!-- Subscription form start  -->
  <form id="subsForm" [formGroup]="subscriptionForm">

    <!-- Stepper start -->
    <mat-horizontal-stepper class="background" #stepper linear (selectionChange)="onStepChange($event)">

      <!-- Select Subscription Step -->
      <mat-step state="doneIcon" formGroupName="packageDetails" [stepControl]="subscriptionForm.get('packageDetails')">
        <ng-template matStepLabel>
          <div class="{{isWebView ? 'stepper-label-wv' :  'stepper-label'}}">Select Subscription</div>
        </ng-template>
        <!--Component: gdo-select-subscription -->
        <app-gdo-select-subscription [type]="'webview'" [currentSelectedPackage]="currentSelectedPackage"
          [subsForm]="subscriptionForm" [title]="title"></app-gdo-select-subscription>
      </mat-step>

      <!-- Subscription Contact Information  Step -->
      <mat-step formGroupName="contactDetails" [stepControl]="subscriptionForm.get('contactDetails')">
        <ng-template matStepLabel>
          <div class="{{isWebView ? 'stepper-label-wv' :  'stepper-label'}}">Subscriber Contact Information</div>
        </ng-template>
        <!-- Component: -->
        <app-gdo-subscription-contact-information [type]="'webview'"
          [subsForm]="subscriptionForm"></app-gdo-subscription-contact-information>
      </mat-step>

      <!-- Payment Method Step -->
      <mat-step formGroupName="paymentDetails" [stepControl]="subscriptionForm.get('paymentDetails')">
        <ng-template matStepLabel>
          <div class="{{isWebView ? 'stepper-label-wv' :  'stepper-label'}}">Payment Method</div>
        </ng-template>
        <!-- Component: -->
        <app-gdo-subscription-payment-method [subsForm]="subscriptionForm"
          [type]="'webview'"></app-gdo-subscription-payment-method>
      </mat-step>


      <!-- Create Pin Step -->
      <mat-step *ngIf="title === 'Purchase Subscription' && showResetPin" formGroupName="pinDetails"
        [stepControl]="subscriptionForm.get('pinDetails')">
        <ng-template matStepLabel>
          <div class="{{isWebView ? 'stepper-label-wv' :  'stepper-label'}}">Create Pin</div>
        </ng-template>
        <!-- Component: -->
        <app-gdo-subscription-create-pin [subsForm]="subscriptionForm"
          [type]="'webview'"></app-gdo-subscription-create-pin>
      </mat-step>


      <!-- Summary Step -->
      <mat-step>
        <ng-template matStepLabel>
          <div  class="{{isWebView ? 'stepper-label-wv' :  'stepper-label'}}">Summary</div>
        </ng-template>
        <!-- Component: -->
        <app-gdo-subscription-summary [parentSubject]="parentSubject" [title]="title" [type]="'webview'"
          [subsForm]="subscriptionForm">
        </app-gdo-subscription-summary>
      </mat-step>


      <!-- This is the done icon that will appear on each tab after completion -->
      <ng-template matStepperIcon="doneIcon"><mat-icon>done</mat-icon></ng-template>
    </mat-horizontal-stepper> <!-- stepper ends -->

    <!-- susbcription Form ends -->
  </form>
</div>
